/* Nordic Weaving: ÉN kilde til leveringsløftet. Oprettet 10/9-2026.

   HVORFOR DENNE FIL FINDES.
   Indtil i dag blev datoen regnet to steder med to forskellige regler. Kurven
   brugte getDayAfterTwoBusinessDays() i temaets main.js, som altid lagde to
   hverdage til og aldrig kiggede på klokken. Produktsiden brugte nw-delivery.js,
   som kendte 14-fristen. Torsdag 10/9 kl. 11.29 lovede produktsiden fredag og
   kurven mandag. Løftet blev altså DÅRLIGERE jo længere kunden kom i købet.

   Lære: når to flader viser det samme løfte, skal de dele koden, ikke bare
   ligne hinanden. Herefter kalder både nw-kurv.js og nw-delivery.js denne fil,
   og der findes kun ét sted at rette reglen.

   REGLEN
     afsendes = i dag, hvis i dag er en pakkedag OG klokken er under 14
                ellers første pakkedag efter i dag
     leveres  = første pakkedag efter afsendelsesdagen

   En pakkedag er en hverdag der ikke er lukkedag.
*/
(function (w) {
  'use strict';

  /* ---- Dansk tid, ikke kundens ur ----
     getHours() læser BESØGENDES lokale ur. En kunde i New York ville få
     14-fristen målt seks timer forskudt og dermed et forkert løfte. Vi læser
     derfor væggens klokke i København uanset hvor kunden sidder.
     Kontrolleret i node med TZ sat til New York og Tokyo: begge gav samme
     danske klokkeslæt. */
  function nuDK() {
    try {
      return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Copenhagen' }));
    } catch (e) {
      return new Date();
    }
  }

  /* ---- Påskedag, Meeus/Jones/Butcher ----
     Beregnes i stedet for at stå i en liste, så filen ikke skal vedligeholdes
     hvert år. Kontrolleret mod 2024 til 2028: 31/3, 20/4, 5/4, 28/3, 16/4. */
  function paaskedag(aar) {
    var a = aar % 19,
        b = Math.floor(aar / 100), c = aar % 100,
        d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25),
        g = Math.floor((b - f + 1) / 3),
        h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4), k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7,
        m = Math.floor((a + 11 * h + 22 * l) / 451),
        md = h + l - 7 * m + 114;
    return new Date(aar, Math.floor(md / 31) - 1, (md % 31) + 1);
  }

  function noegle(dato) {
    return dato.getFullYear() + '-' + (dato.getMonth() + 1) + '-' + dato.getDate();
  }

  /* ---- LUKKEDAGE ----
     Afklaret med Mads 10/9-2026: lageret har folk på arbejde ALLE hverdage,
     og den eneste dag NW selv lukker er den 24. december. Julen styres i
     stedet med en besked om at bestille inden en bestemt dato, ikke i koden.

     De øvrige dage herunder er ikke NW's valg. Det er de danske helligdage
     hvor GLS ikke kører, og hvor et løfte om levering derfor ikke kan holdes
     uanset hvem der møder ind på lageret. Tager jeg fejl om nogen af dem, er
     de nemme at stryge: det er én linje hver.

     STORE BEDEDAG ER IKKE MED. Den blev afskaffet som helligdag i 2024.
     Læg den ikke ind igen.

     IKKE MED, fordi det er halve dage og ikke helligdage: Grundlovsdag 5. juni
     og nytårsaftensdag 31. december. GLS kører begge dage, bare kortere.
     Skal de med, er det en beslutning om hvor forsigtige vi vil være, ikke en
     rettelse af en fejl. */
  var cache = {};

  function lukkedage(aar) {
    if (cache[aar]) return cache[aar];

    var s = {};
    function luk(dato) { s[noegle(dato)] = true; }
    function fraPaaske(n) {
      var dt = paaskedag(aar);
      dt.setDate(dt.getDate() + n);
      return dt;
    }

    luk(new Date(aar, 0, 1));    // nytårsdag
    luk(fraPaaske(-3));          // skærtorsdag
    luk(fraPaaske(-2));          // langfredag
    luk(fraPaaske(1));           // 2. påskedag
    luk(fraPaaske(39));          // Kristi himmelfartsdag
    luk(fraPaaske(50));          // 2. pinsedag
    luk(new Date(aar, 11, 24));  // juleaften, NW's egen lukkedag
    luk(new Date(aar, 11, 25));  // 1. juledag
    luk(new Date(aar, 11, 26));  // 2. juledag

    cache[aar] = s;
    return s;
  }

  function erPakkedag(dato) {
    var wd = dato.getDay();
    if (wd === 0 || wd === 6) return false;
    return !lukkedage(dato.getFullYear())[noegle(dato)];
  }

  function naestePakkedag(dato) {
    var n = new Date(dato);
    /* Loftet på 30 er en sikring, ikke en forventning. Uden det ville en fejl
       i lukkedage() kunne give en uendelig løkke der fryser siden. */
    for (var i = 0; i < 30; i++) {
      n.setDate(n.getDate() + 1);
      if (erPakkedag(n)) return n;
    }
    return n;
  }

  var DAGE = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
  var MDR = ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'];

  w.NWLev = {
    erPakkedag: erPakkedag,

    /* nu er valgfri og kun til test. I drift skal den udelades, så vi altid
       regner på dansk tid. */
    beregn: function (nu) {
      nu = nu || nuDK();
      var kanPakkesIDag = erPakkedag(nu) && nu.getHours() < 14;
      var afsendes = kanPakkesIDag ? nu : naestePakkedag(nu);
      var leveres = naestePakkedag(afsendes);
      return {
        kanPakkesIDag: kanPakkesIDag,
        dato: leveres,
        ugedag: DAGE[leveres.getDay()],
        tekst: DAGE[leveres.getDay()] + ' ' + leveres.getDate() + '. ' + MDR[leveres.getMonth()]
      };
    }
  };
})(window);
